import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  bodyCell: {
    wordBreak: "break-word",
  }
}));
export default styles;